import { Manager } from 'socket.io-client';

export default {
  /**
   * Find all store actions with `socket_` prefix and register listeners.
   * Then bind `$socket` client to to Vue.
   */
  install(app, options) {
    const {
      store,
      actionPrefix = 'socket_',
    } = options;

    const manager = new Manager(process.env.SOCKETS_URL, {
      path: '/s',
      port: 443,
      secure: true,
      withCredentials: true,
    });

    // eslint-disable-next-line no-param-reassign
    const socket = manager.socket('/producer');

    app.provide('$manager', manager);
    app.provide('$socket', socket);

    const actions = store._actions; // eslint-disable-line no-underscore-dangle
    const socketActions = Object.keys(actions).filter((name) => name.indexOf(actionPrefix) === 0);

    // Setup reconnect handler, which is only available on the Manager.
    manager.on('reconnect', (...args) => {
      // Proxy to socket_reconnect store action
      store.dispatch('socket_reconnect', ...args);
    });

    socketActions.forEach((action) => {
      const eventName = action.substr(actionPrefix.length);

      socket.on(eventName, (...args) => {
        store.dispatch(action, ...args);
      });
    });

    window.$manager = manager;
    window.$socket = socket;
  },
};
